import React from 'react'
import PropTypes from 'prop-types'
import { Modal as EPModal } from '@elparking/components'
import DownloadAppBlock from 'rental-car-contract/js/containers/RentalCarDetailContainer/DownloadAppBlock'

const DownloadMobileApp = ({ isShown, onClose, onAccept, bookingId }) => {
      return <EPModal isShown={isShown} onClose={onClose} width='812px' label=' ' showModalTitle={false}>
          <DownloadAppBlock onAccept={onAccept} bookingId={bookingId} />
      </EPModal>
}

DownloadMobileApp.propTypes = {
    isShown: PropTypes.bool,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
    bookingId: PropTypes.number,
}
export default DownloadMobileApp
